<a
    class="layout-topbar-logo"
    routerLink=""
    style="
        display: block;
        text-align: center;
        border-bottom: 1px dashed #393945;
        margin-bottom: 20px;
    "
>
    <img
        [src]="_globals.whiteLabel.logoWhite"
        alt="Logo"
        height="80"
        width="150"
        [style]="{ 'margin-bottom': '30px' }"
    />
</a>

<p-scrollPanel
    [style]="{
        'margin-right': '0px',
        width: '100%',
        height: 'calc(87vh - 9rem)'
    }"
>

    <div class="menu-skeleton" *ngIf="_abd.isMenuRefreshing">
        <p-skeleton *ngFor="let row of [1,2,3,4,5,6,7]" width="85%" height="1.75rem" styleClass="mb-3"></p-skeleton>
    </div>
    <p-panelMenu
        *ngIf="!_abd.isMenuRefreshing"
        class="active-menu-style"
        [model]="this._abd.appLeftMenu"
        [style]="{ width: '100%' }"
        [multiple]="false"
    >
    </p-panelMenu>
</p-scrollPanel>
        <!-- Footer -->
        <div   style="
        display: block;
        text-align: center;
        padding-top:10px;
        margin-top: 20px;
        border-top: 1px dashed #393945;
    ">
            <span *ngIf="!_abd.isAdmin && _globals.whiteLabel.isDownloadPOSAPP === true" class="font-bold px-2 my-4 cursor-pointer open-app" style="color: var(--brandColor);" (click)="opnePosDownload()">
            Download Point of Sale App
        </span>
        </div>
       